function HeaderMenu() {
    return (
        <div className="header_main">
            <ul className="header_menu">
                <li className="header_menu_item">
                    <img alt="" src="/img/arrow.svg"></img><a href="#ShelfAcoustics">Полочная акустика</a>
                </li>
                <li className="header_menu_item">
                    <img alt="" src="/img/arrow.svg"></img><a href="#FloorAcoustics">Напольная акустика</a>
                </li>
                <li className="header_menu_item">
                <img alt="" src="/img/arrow.svg"></img><a href="#CenterChannelAcoustics">Акустика центрального канала</a>
                </li>
                <li className="header_menu_item">
                <img alt="" src="/img/arrow.svg"></img><a href="#WallAcoustics">Настенная акустика</a>
                </li>
                <li className="header_menu_item">
                <img alt="" src="/img/arrow.svg"></img><a href="#AcousticsDolby">Акустика Dolby</a>
                </li>
                <li className="header_menu_item">
                <img alt="" src="/img/arrow.svg"></img><a href="#Subwoofer">Сабвуферы</a>
                </li>
            </ul>
        </div>
    )
}
export default HeaderMenu;